import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AppState {
  isLoadedHeader: boolean
  isRefreshVipInfo: boolean
  isRefreshSkinTotal: boolean
  isTopupModalOpen: boolean // 新增控制 topup modal 的状态
  isOpeningBox: boolean
  isReChargeSuccess: boolean // 是否充值成功
  isOpenMySkinsModal: boolean // 我的皮肤弹窗
  isOpenTradeUrl?: boolean // 是否打开交易链接弹窗
  isRefreshBalance: boolean // 是否刷新余额
}

const initialState: AppState = {
  isLoadedHeader: true,
  isRefreshVipInfo: false,
  isRefreshSkinTotal: false,
  isTopupModalOpen: false, // 初始状态为关闭
  isOpeningBox: false,
  isReChargeSuccess: false,
  isOpenMySkinsModal: false,
  isOpenTradeUrl: false,
  isRefreshBalance: false,
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setIsLoadedHeader: (state, action: PayloadAction<boolean>) => {
      state.isLoadedHeader = action.payload
    },
    setIsRefreshVipInfo: (state, action: PayloadAction<boolean>) => {
      state.isRefreshVipInfo = action.payload
    },
    setIsRefreshSkinTotal: (state, action: PayloadAction<boolean>) => {
      state.isRefreshSkinTotal = action.payload
    },
    // 新增 action
    setIsTopupModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isTopupModalOpen = action.payload
    },
    setIsOpeningBox: (state, action: PayloadAction<boolean>) => {
      state.isOpeningBox = action.payload
    },
    setIsReChargeSuccess: (state, action: PayloadAction<boolean>) => {
      state.isReChargeSuccess = action.payload
    },
    setIsOpenMySkinsModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenMySkinsModal = action.payload
    },
    setIsOpenTradeUrl: (state, action: PayloadAction<boolean>) => {
      state.isOpenTradeUrl = action.payload
    },
    setIsRefreshBalance: (state, action: PayloadAction<boolean>) => {
      state.isRefreshBalance = action.payload
    },
  },
})

export const {
  setIsLoadedHeader,
  setIsRefreshVipInfo,
  setIsRefreshSkinTotal,
  setIsTopupModalOpen, // 导出新的 action
  setIsOpeningBox,
  setIsReChargeSuccess,
  setIsOpenMySkinsModal,
  setIsOpenTradeUrl,
  setIsRefreshBalance,
} = appSlice.actions

export default appSlice
